<template>
  <div class="assistant-popover__fieldset">
    <p>Добавленные ассистенты <span v-if="assistants.length && appStore.features.manageAssistants">({{ assistants.length }}/3)</span></p>
    <div v-if="assistants.length === 1">
      <div
          v-for="assistant in assistants"
          :key="assistant.id"
          class="assistant-popover__row"
      >
        <Avatar size="small" :image="assistant.assistantInfo.icon" shape="circle"/>
        <div class="assistant-popover__assistant-info">
          <div>
            {{ assistant.assistantInfo.name }}
          </div>
        </div>
        <AssistantRowButtons
            :mode="ASSISTANT_BUTTONS_MODE.SELECTED"
            :assistant-id="assistant.assistant_id"
            :assistant="assistant.assistantInfo"
            @detach="(id) => $emit('detach', id)"
            @view="(assistant) => $emit('view', assistant)"
        />
      </div>
    </div>
    <draggable
        v-else
        :list="assistants"
        item-key="order"
        handle=".drag-handle"
        class="assistant-popover__rows"
        @change="$emit('reorder', $event.moved)"
    >
      <template #item="{ element }">
        <div class="assistant-popover__row">
          <div class="drag-handle">
            <i class="pi pi-bars"></i>
          </div>
          <Avatar size="small" :image="element.assistantInfo.icon" shape="circle"/>
          <div class="assistant-popover__assistant-info">
            <div class="assistant-popover__assistant-external-info">
              {{ element.assistantInfo.name }}
            </div>
          </div>
          <AssistantRowButtons
              :mode="ASSISTANT_BUTTONS_MODE.SELECTED"
              :assistant-id="element.assistant_id"
              :assistant="element.assistantInfo"
              @detach="(id) => $emit('detach', id)"
              @view="(assistant) => $emit('view', assistant)"
          />
        </div>
      </template>
    </draggable>
  </div>
</template>

<script setup>
import Avatar from "primevue/avatar";
import draggable from 'vuedraggable';
import AssistantRowButtons from "@/modules/chat/components/assisstant/Popover/AssistantRowButtons.vue";
import {ASSISTANT_BUTTONS_MODE} from "@/constants";

import {useAppStateStore} from "@/modules/chat/stores/appStore";

const appStore = useAppStateStore();


defineProps({
  assistants: {
    type: Array,
    required: true
  }
});

defineEmits(['detach', 'reorder', 'view']);
</script>
